import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Flex } from 'antd';

import ListingBackground from '@/assets/company-listing/listing-bg.png';
import { useSelectedCompanyStore } from '@/stores/selectedCompany';
import { useGetCompany } from '@/features/company/api/getCompany';

const CompanyListingLayout = styled(Flex)`
  background-image: url(${ListingBackground});
  background-size: cover;
  background-repeat: no-repeat;
  width: 100%;
`;

const RouteWrapper = () => {
  const navigate = useNavigate();
  const { selectedCompany } = useSelectedCompanyStore((state) => state);
  const { data: companyData } = useGetCompany({
    companyID: selectedCompany?.cid as number,
  });

  useEffect(() => {
    const companyListingFeature = companyData?.current_plan.features.filter(({ key }) => key === 'company.forsale');

    if (companyListingFeature?.length) {
      const [{ premium, included }] = companyListingFeature;
      if (!(premium && included)) {
        navigate(selectedCompany?.is_owner ? '/company/dashboard' : '/company/investment-overview/my-investments');
      }
      if (companyData?.company_data.is_listed) {
        navigate('/company-listing/thank-you');
      }
    }
  }, [companyData, selectedCompany?.is_owner, navigate]);

  return (
    <CompanyListingLayout vertical align="center" justify="center">
      <Outlet />
    </CompanyListingLayout>
  );
};

export default RouteWrapper;
